import * as React from "react";
import { withLocalize, Translate } from "react-localize-redux";
const LanguageToggle = ({ languages, activeLanguage, setActiveLanguage }) => (

  <ul className="languageSelector">
    {languages.map(lang => (
      <li style={{
        display: activeLanguage.code==lang.code? "none" : "block",
        cursor: "pointer"
        }}
        key={lang.code}
        onClick={() => setActiveLanguage(lang.code)}>
        <Translate id="changeLanguage" data={{name: lang.name}} />
      </li>
    ))}
  </ul>
);

export default withLocalize(LanguageToggle);



// WEBPACK FOOTER //
// ./src/_layout/languageToggle/LanguageToggle.jsx